export class HistogramRequestModel {
    public configs = '';
    public filters = '';
}